import React from "react";

import overValue from "../assets/slider6.jpg";

import getInTouch from "../assets/getintouch.png";

import aboutBanner from "../assets/about_banner.png";
import aboutBanner3 from "../assets/about_banner3.png";
import philosophy1 from "../assets/philosophy1.png";
import philosophy2 from "../assets/philosophy2.png";
import philosophy3 from "../assets/philosophy3.png";
import philosophy4 from "../assets/philosophy4.png";
import check from "../assets/check.png";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "react-router-dom";

function About() {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const counters = gsap.utils.toArray(".wrapper-img");

    counters.forEach((counter) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: counter,
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play none none none",
        },
      });

      tl.fromTo(
        counter.querySelector(".img-holder"),
        { xPercent: 100 },
        { duration: 2.5, xPercent: 0, ease: "power2.out" }
      ).fromTo(
        counter.querySelector(".img-holder img"),
        { xPercent: -100 },
        { duration: 2.5, xPercent: 0, ease: "power2.out" },
        "<"
      );
    });
    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);
  return (
    <div>
      <Header />
      <div className="relative w-full">
        {/* Banner Image */}
        <img
          src={aboutBanner}
          alt="aboutBanner"
          className="w-full h-auto object-cover banner-img"
        />

        {/* Overlay Text */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h2
            data-aos="fade-up"
            className="text-white text-4xl md:text-5xl  title-font-heading"
          >
            About us
          </h2>
        </div>
      </div>
      <section className="bg-white padding-aboutus-content">
        <div className="mx-auto grid md:grid-cols-2 gap-10 items-start">
          {/* Left side heading */}
          <div>
            <h2 data-aos="fade-up" className="aboutus-title">
              Who we are?
            </h2>
          </div>

          {/* Right side content */}
          <div className="aboutus-content">
            <p data-aos="fade-up">
              Bhagwati Engineering is a Limited Liability Partnership firm based
              in Girgaon, Mumbai. Since 2017, we have delivered complex
              construction projects across the city with the goal of
              transforming urban spaces through ethical, efficient, and expert
              execution. We pride ourselves on a process-oriented approach,
              combining modern equipment, experienced personnel, and deep
              industry know-how to provide top-tier construction services.
            </p>
          </div>
        </div>
      </section>
      <div class="wrapper-img">
        <div className="img-holder">
          <img
            src={aboutBanner3}
            alt="Construction Site"
            className="w-full h-full object-cover heign-banner"
          />
        </div>
      </div>
      <div className="bg-[#153280] about-philo py-24 text-white grid grid-cols-1 lg:grid-cols-2 gap-10">
        <h2 data-aos="fade-up" className="about-philo-title">
          Core Philosophy
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-10">
          {/* Item 1 */}
          <div data-aos="fade-up" className="philo-card items-start">
            {/* Replace with your icon */}
            <img src={philosophy1} alt="Discipline in Execution" />
            <h3 className="font-bold text-lg">Discipline in Execution</h3>
            <p className="text-sm mt-1">
              Every project follows a detailed development cycle, from
              mobilisation to finishing, to ensure consistency and control.
            </p>
          </div>

          {/* Item 2 */}
          <div
            data-aos="fade-up"
            data-aos-delay="450"
            className="philo-card items-start"
          >
            <img src={philosophy2} alt="Discipline in Execution" />

            <h3 className="font-bold text-lg">Transparency & Accountability</h3>
            <p className="text-sm mt-1">
              Full compliance with local laws, building codes, and safety
              regulations ensures peace of mind for our clients.
            </p>
          </div>

          {/* Item 3 */}
          <div
            data-aos="fade-up"
            data-aos-delay="650"
            className="philo-card items-start"
          >
            <img src={philosophy3} alt="Discipline in Execution" />

            <h3 className="font-bold text-lg">People-First Approach</h3>
            <p className="text-sm mt-1">
              A healthy, secure, and responsive work environment for both our
              team and the communities we serve.
            </p>
          </div>

          {/* Item 4 */}
          <div
            data-aos="fade-up"
            data-aos-delay="850"
            className="philo-card items-start"
          >
            <img src={philosophy4} alt="Discipline in Execution" />

            <h3 className="font-bold text-lg">Future-Ready</h3>
            <p className="text-sm mt-1">
              We invest in the latest construction tools, techniques, and people
              development to deliver lasting quality.
            </p>
          </div>
        </div>
      </div>
      <div className="skyscraper-view">
        <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-1 gap-12 items-center">
          {/* Left Text Content */}
          <div className="skyscraper-text-content">
            <h2 data-aos="fade-up">Our Value Proposition</h2>
            <p data-aos="fade-up" className="para">
              What Makes Us the Right Partner?
            </p>

            <div className="skyscraper-list">
              {[
                {
                  title: "Engineering Excellence",
                  description:
                    "We don’t cut corners we align with leading consultants and architects for sound structural work.",
                },
                {
                  title: "Self-sufficient Execution",
                  description:
                    "With our own equipment and manpower, we avoid project delays and ensure quality control.",
                },
                {
                  title: "Safety-First Culture",
                  description:
                    "Zero-compromise approach to site safety, labor welfare, and legal compliance.",
                },
                {
                  title: "Project Discipline",
                  description:
                    "Daily progress reports, labor management, BOQ control, and milestone tracking from day one.",
                },
                {
                  title: "Client-Centric Approach",
                  description:
                    "Every client is a long-term relationship. We believe in transparency, responsiveness, and service.",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="skyscraper-list-item flex items-start "
                >
                  <img
                    data-aos="fade-up"
                    data-aos-delay={`${400 + index * 100}`}
                    src={check}
                    alt="Checkmark"
                  />
                  <div
                    data-aos="fade-up"
                    data-aos-delay={`${400 + index * 100}`}
                  >
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="rounded-lg overflow-hidden skyscraper-image">
            <div class="wrapper-img">
              <div className="img-holder">
                <img src={overValue} alt="Skyscraper View" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Get in Touch */}
      <section className="bg-[#1C3E9A] text-white px-6 main-cta-card md:px-28">
        <div className="col-flex flex flex-col md:flex-row items-center justify-between">
          {/* Left: Text */}
          <div className="md:w-1/2 text-center md:text-left cta-headong">
            <h3 data-aos="fade-up">Get in Touch</h3>
            <h2 data-aos="fade-up">
              Time to take action? <br className="hidden md:block" />
              Get a quote today
            </h2>
            <Link to="/contact">
              <button
                data-aos="fade-up"
                className="uppercase bg-white text-[#1C3E9A] px-6 py-2 mt-6 rounded-full"
              >
                Get a Quote
              </button>
            </Link>
          </div>

          {/* Right: Image */}
          <div className="md:w-1/2 mt-8 md:mt-0 flex justify-center">
            <img
              data-aos="zoom-in-up"
              src={getInTouch}
              alt="Engineers"
              className="h-90 w-100 object-contain"
            />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default About;
